import type { ExportFormat } from '../types/export';

export const EXPORT_FORMAT_FILE_EXTENSIONS = {
  csv: 'csv',
  json: 'json',
  xlsx: 'xlsx',
} satisfies Record<ExportFormat, string>;

export const EXPORT_FORMAT_MIME_TYPES = {
  csv: 'text/csv',
  json: 'application/json',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
} satisfies Record<ExportFormat, string>;

export const EXPORT_FORMAT_LABELS = {
  csv: 'CSV',
  json: 'JSON',
  // The format tab reads as the app the reader will open the file in, not the container format.
  xlsx: 'Excel',
} satisfies Record<ExportFormat, string>;
